<template>
    <section class="small-right">
        <div class="spacing space-between">

            <div>

                <h2>Explore 5G voice’s foundation and new service opportunities</h2>
                <h3>Why voice is essential for every CSP’s business plan.</h3>

                <p>Voice has a vitally important role in Communications Service Providers’ (CSP) 5G business models. People naturally expect voice in their subscription. And with 5G, voice will provide exciting new capabilities as an integral part of innovative data services.</p>

            </div>

            <infobutton>
                Voice revenues vary widely between CSPs in different markets, yet it remains a non-negotiable part of the package for mobile subscribers everywhere.
            </infobutton>

        </div>
        <div class="spacing center gray">

            <lottie :name="'introduction/icon-1-voice-phone'" :width="400" :height="604" />

        </div>
    </section>
</template>

<script>

    import globalMixin from '@/mixins/globalMixin.js';

    export default {
        mixins: [globalMixin],
    }

</script>

<style lang="scss" scoped>

    // ...

</style>